import { Dispatch } from 'react'

interface State {
  isHidden: boolean
}

// 현재 닫힌 배너를 아직 다시 보여주는 로직이 없기 때문에, HIDE만 있으면 됨
interface Action {
  type: 'HIDE'
}

export const topDownloadBannerInitialState: State = {
  isHidden: false,
}

export function topDownloadBannerReducer(state: State, action: Action): State {
  switch (action.type) {
    case 'HIDE':
      return { ...state, isHidden: true }
    default:
      throw Error('unknown action')
  }
}

export interface TopDownloadBannerContext {
  topDownloadBanner: State
  topDownloadBannerDispatch: Dispatch<Action>
}
